<template>
  <div class="faraday-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$θ = V · B · L$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>磁场强度 B</label>
            <span class="val">{{ bField.toFixed(2) }} T</span>
          </div>
          <div class="hud-item orange">
            <label>旋光角度 θ</label>
            <span class="val">{{ rotationAngle.toFixed(1) }}°</span>
          </div>
        </div>

        <!-- 三维透视演示 (SVG 模拟) -->
        <svg width="100%" height="240" viewBox="0 0 400 240" preserveAspectRatio="xMidYMid meet">
          <!-- 背景磁感应线 -->
          <g v-if="bField > 0">
            <line v-for="i in 5" :key="i" x1="50" :y1="60+i*20" x2="350" :y2="60+i*20" 
                  stroke="rgba(245, 158, 11, 0.2)" stroke-width="1" stroke-dasharray="10,5" />
          </g>
          
          <!-- 入射偏振光 (垂直) -->
          <g transform="translate(60, 120)">
             <path :d="`M -10,-40 L 10,40`" stroke="#f43f5e" stroke-width="4" stroke-linecap="round" />
             <text x="0" y="55" text-anchor="middle" fill="#f43f5e" font-size="10" font-weight="900">入射偏振线</text>
          </g>

          <!-- 磁光介质 (Verdet 介质) -->
          <rect x="120" y="70" width="160" height="100" fill="rgba(6, 182, 212, 0.1)" stroke="#06b6d4" stroke-width="1.5" />
          <text x="200" y="185" text-anchor="middle" fill="#06b6d4" font-size="10">磁光介质 (L=160mm)</text>

          <!-- 出射旋转光 -->
          <g :transform="`translate(340, 120) rotate(${rotationAngle})`">
             <path :d="`M -10,-40 L 10,40`" stroke="#10b981" stroke-width="6" stroke-linecap="round" />
             <path d="M 0,-40 L -4,-32 M 0,-40 L 4,-32" stroke="#10b981" stroke-width="2" />
             <text x="0" y="55" :transform="`rotate(${-rotationAngle})`" text-anchor="middle" fill="#10b981" font-size="10" font-weight="900">旋转后偏振线</text>
          </g>

          <!-- 角度提示弧 -->
          <path :d="describeArc(340, 120, 30, 0, rotationAngle)" fill="none" stroke="#fbbf24" stroke-width="2" stroke-dasharray="2,2" />
        </svg>

        <div class="physics-caption" v-latex>
          <strong>物理规律：</strong>法拉第旋转描述了光在磁场作用下的磁光效应。出射光的偏振面相对于入射面旋转的角度 $\theta$ 与磁感应强度 $B$ 成正比。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="label-row">
             <span class="label">调节磁场强度 (Tesla)</span>
             <el-slider v-model="bField" :min="0" :max="5" :step="0.05" size="small"></el-slider>
           </div>
        </div>
        
        <div class="discovery-card-discovery" v-latex>
           <i class="el-icon-zoom-in"></i>
           <p><strong>实战物理：</strong>这一效应是磁光隔离器（激光器的非互逆器件）的核心原理。<strong>观察：</strong>随着你增大磁场强度，出射绿光线的倾角 $\theta$ 会线性增大。这展示了磁场是如何“干预”电磁波的极化矢量的。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'FaradayRotationViz',
  data() {
    return {
      bField: 1.2,
      verdetConst: 15 // 模拟系数
    }
  },
  computed: {
    rotationAngle() {
      return this.bField * this.verdetConst;
    }
  },
  methods: {
    polarToCartesian(centerX, centerY, radius, angleInDegrees) {
      const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
      return {
        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians))
      };
    },
    describeArc(x, y, radius, startAngle, endAngle){
      const start = this.polarToCartesian(x, y, radius, endAngle);
      const end = this.polarToCartesian(x, y, radius, startAngle);
      const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
      return [
        "M", start.x, start.y, 
        "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
      ].join(" ");
    }
  }
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.faraday-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
.label-row { display: flex; flex-direction: column; gap: 4px; .label { font-size: 11.5px; color: #64748b; font-weight: 800; } }
</style>
